// @ts-nocheck
import { createAction } from '@reduxjs/toolkit';
import * as query from './query';

export const deleteGroup = createAction(query.createActionName('delete-group'), (groupId, groups) => {
	return {
		payload: { groupId, groups },
	};
});
